import React, { Component } from 'react';
import { connect } from "react-redux";
import './Main.css';
import { Table, Container, Card, Button, ButtonGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


export default class Summary2 extends Component {

  render() {

    if(!this.props.target)
      return ""

		// キーと値を1次元に展開
		const settings = this.props.target?.setting || [];
    const flattenedSettings = settings.flatMap(obj =>
      Object.entries(obj).map(([key, value]) => ({ key, value }))
    );

    const { target } = this.props;

    return (
      <span>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '8px', gap: '8px' }}>
          {target.session_url && (
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => target.downloadRawData()}
              title="セッションのRAWデータ（CSV形式）をダウンロードします"
              style={{ fontWeight: 'bold' }}
            >
              <FontAwesomeIcon icon="file-csv" style={{ marginRight: '5px' }} />
              RAWデータ(CSV) DL
            </Button>
          )}
          {target.excel_url && (
            <Button
              variant="outline-success"
              size="sm"
              onClick={() => window.open(target.excel_url)}
              title="Excel集計データをダウンロードします"
              style={{ fontWeight: 'bold' }}
            >
              <FontAwesomeIcon icon="file-excel" style={{ marginRight: '5px' }} />
              Excel DL
            </Button>
          )}
        </div>
        <Table striped bordered hover variant="dark">
          <tbody>
            <tr>
              <td className="GridData2" ><div className="Unit2">max SPD</div><span className="summary"> {this.props.target.max_speed}</span><span className="Unit2">{this.props.authUser.unit}</span></td>
              <td className="GridData2" ><div className="Unit2">ave SPD</div><span className="summary">  {this.props.target.ave_speed}</span><span className="Unit2">{this.props.authUser.unit}</span></td>
              <td className="GridData2" ><div className="Unit2">max 2s SPD</div><span className="summary">  {this.props.target.max_2s_spd}</span><span className="Unit2">{this.props.authUser.unit}</span></td>
              <td className="GridData2" ><div className="Unit2">max 10s SPD</div><span className="summary">  {this.props.target.max_10s_spd}</span><span className="Unit2">{this.props.authUser.unit}</span></td>
            </tr>
            <tr>
              <td className="GridData2" ><div className="Unit2">max up VMG</div><span className="summary">  {this.props.target.max_vmg_up}</span><span className="Unit2">{this.props.authUser.unit}</span></td>
              <td className="GridData2" ><div className="Unit2">ave up VMG</div><span className="summary">  {this.props.target.ave_vmg_up}</span><span className="Unit2">{this.props.authUser.unit}</span></td>
              <td className="GridData2" ><div className="Unit2">max down VMG</div><span className="summary">  {this.props.target.max_vmg_down}</span><span className="Unit2">{this.props.authUser.unit}</span></td>
              <td className="GridData2" ><div className="Unit2">ave down VMG</div><span className="summary">  {this.props.target.ave_vmg_down}</span><span className="Unit2">{this.props.authUser.unit}</span></td>
            </tr>
            <tr>
              <td className="GridData2" ><div className="Unit2">ave Pitch</div><span className="summary">  {this.props.target.ave_pitch}</span><span className="Unit2">{"deg"}</span></td>
              <td className="GridData2" ><div className="Unit2">ave Roll</div><span className="summary">  {this.props.target.ave_roll}</span><span className="Unit2">{"deg"}</span></td>
            </tr>

          </tbody>
        </Table>
     </span>
    );
  };
}
